<app-alerts />

@if (form$ | async; as form) {
  <app-admin-product-details-form
    [canBeWarehouseGoodEdited]="form.canBeWarehouseProductIdEdited"
    [isEditContext]="true"
    (submitClickEvent)="handleSubmitClickEvent($event)"
    [data]="form" />
} @else {
  <app-spinner-filled />
}
